import { useEffect, useState } from "react";
import BlogImg from "../assets/img/zenBlog.png";
import config from "../config/env";
import MinimalLoader from "./Loader";
import NewsCard from "./NewsCard";

const PostsComponent = ({ category }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setLoading(true);

    let apiUrl;

    if (category) {
      apiUrl = `${config.API_URL}/api/posts?category=${category}`;
    } else {
      apiUrl = `${config.API_URL}/api/posts?page=${currentPage}`;
    }

    fetch(apiUrl)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setTotalPages(Number(data.pagination.totalPages));
        setPosts(data.posts);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching posts:", error);
        setLoading(false);
      });
  }, [category, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  if (loading) {
    return (
      <div className="container mx-auto flex justify-center items-center">
        <MinimalLoader />
      </div>
    );
  }

  return (
    <div className="container mx-auto pt-10 md:pt-40">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3  xl:grid-cols-3 justify-between gap-4 md:gap-6 xl:gap-8 px-4 md:px-12">
        {posts.map((post) => (
          <NewsCard
            key={post?.id}
            title={post?.title}
            href={`/news/${post?.slug}`}
            imgSrc={post?.featured_image ? `${post?.featured_image}` : BlogImg}
            tag={post?.category}
          />
        ))}
      </div>

      {/* Pagination Buttons */}
      <div className="flex justify-center items-center gap-4 mt-8">
        <button
          className="px-4 py-2 bg-gray-200 rounded disabled:text-gray"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            className={`px-3 py-1 rounded-full ${
              currentPage === index + 1
                ? "bg-primary text-white"
                : "bg-gray-200"
            }`}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}
        <button
          className="px-4 py-2 bg-gray-200 rounded disabled:text-gray"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PostsComponent;
